export interface ListContinuationEdit {
  newValue: string
  newCursorPos: number
}

const BULLET_LINE = /^• (.*)$/
const NUMBERED_LINE = /^(\d+)\. (.*)$/

export function getListContinuationEdit(value: string, cursorPos: number): ListContinuationEdit | null {
  const before = value.substring(0, cursorPos)
  const after = value.substring(cursorPos)
  const lineStart = before.lastIndexOf('\n') + 1
  const currentLine = before.substring(lineStart)

  const bulletMatch = currentLine.match(BULLET_LINE)
  if (bulletMatch) {
    if (bulletMatch[1].trim() === '') {
      const newValue = value.substring(0, lineStart) + '\n' + after
      return { newValue, newCursorPos: lineStart + 1 }
    }
    const insertion = '\n• '
    return { newValue: before + insertion + after, newCursorPos: cursorPos + insertion.length }
  }

  const numberedMatch = currentLine.match(NUMBERED_LINE)
  if (numberedMatch) {
    if (numberedMatch[2].trim() === '') {
      const newValue = value.substring(0, lineStart) + '\n' + after
      return { newValue, newCursorPos: lineStart + 1 }
    }
    const nextNumber = parseInt(numberedMatch[1], 10) + 1
    const insertion = `\n${nextNumber}. `
    return { newValue: before + insertion + after, newCursorPos: cursorPos + insertion.length }
  }

  return null
}
